var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline"},[_c('div',{staticClass:"timeline__progress",style:(`transition-duration: 100ms; width: ${_vm.playbackPercentage}%`)}),_c('div',{staticClass:"timeline__events"},_vm._l((_vm.playbackEvents),function(event,i){return _c('div',{key:'event' + i,staticClass:"event",class:[
        {'event--click': event.type === 'click'},
        {'event--drag': event.type === 'dragging'},
      ],style:(`left: ${event.position}%`)})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }